<audio #notifyAudio style="display: none;">
  <source src="assets/sounds/notify.mp3" type="audio/mpeg">
</audio>
